import LEADIN_API_FORM_TYPES from 'forms-utils-lib/constants/formDefinition/LeadinApiFormTypes';
export function getCurrentForm(state, guid) {
  return guid && state.form.currentForm && state.form.currentForm.guid !== guid ? undefined : state.form.currentForm;
}
export function getFormRequestState(state) {
  return state.form.fetchRequestState;
}
export const getCurrentFormType = state => state.form.currentForm.formType;
export const getIsLeadAd = state => !!LEADIN_API_FORM_TYPES.includes(getCurrentFormType(state));